module.exports = __webpack_public_path__ + "static/services-img14-b53fe50300493ba5ec155eb0b07a41f7.png";